import {
  Activity,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  Bell,
  BellOff,
  Book,
  BookOpen,
  BookOpenCheck,
  Calendar,
  CalendarDays,
  ChartColumn,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleCheck,
  CircleDot,
  CircleHelp,
  CircleUser,
  ClipboardCopy,
  CloudCheck,
  CloudUpload,
  Coffee,
  Copy,
  Crown,
  Database,
  Download,
  Ellipsis,
  ExternalLink,
  Eye,
  EyeOff,
  FileText,
  Flame,
  Folder,
  Funnel,
  FunnelX,
  GitCompare,
  Hash,
  Hourglass,
  Image,
  ImageMinus,
  ImagePlus,
  Inbox,
  Info,
  Key,
  Keyboard,
  Languages,
  Layers,
  Lightbulb,
  ListChecks,
  Lock,
  LockOpen,
  LogIn,
  LogOut,
  Mail,
  Menu,
  Moon,
  OctagonAlert,
  Palette,
  Pause,
  Pencil,
  Play,
  Plus,
  RefreshCw,
  RotateCcw,
  RotateCcwClock,
  RotateCw,
  Save,
  Search,
  SearchX,
  Settings,
  Share2,
  ShieldAlert,
  SlidersHorizontal,
  Square,
  Target,
  Timer,
  Trash,
  TriangleAlert,
  Trophy,
  Upload,
  User,
  UserCheck,
  UserCog,
  UserMinus,
  UserPlus,
  Users,
  UsersRound,
  Wifi,
  WifiOff,
  X,
  Zap,
  ZapOff
} from '@lucide/svelte';

export const ICONS = {
  activity: Activity,
  'alert-circle': CircleAlert,
  'alert-octagon': OctagonAlert,
  'alert-triangle': TriangleAlert,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'arrow-up-down': ArrowUpDown,
  'bar-chart-3': ChartColumn,
  bell: Bell,
  'bell-off': BellOff,
  book: Book,
  'book-open': BookOpen,
  'book-open-check': BookOpenCheck,
  calendar: Calendar,
  'calendar-days': CalendarDays,
  check: Check,
  'check-circle': CircleCheck,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'circle-alert': CircleAlert,
  'circle-dot': CircleDot,
  'circle-help': CircleHelp,
  'circle-user': CircleUser,
  'clipboard-copy': ClipboardCopy,
  'cloud-check': CloudCheck,
  'cloud-upload': CloudUpload,
  coffee: Coffee,
  copy: Copy,
  crown: Crown,
  database: Database,
  download: Download,
  ellipsis: Ellipsis,
  'external-link': ExternalLink,
  eye: Eye,
  'eye-off': EyeOff,
  'file-text': FileText,
  filter: Funnel,
  'filter-x': FunnelX,
  flame: Flame,
  folder: Folder,
  'git-compare': GitCompare,
  hash: Hash,
  'help-circle': CircleHelp,
  history: RotateCcwClock,
  image: Image,
  'image-minus': ImageMinus,
  'image-plus': ImagePlus,
  inbox: Inbox,
  info: Info,
  key: Key,
  keyboard: Keyboard,
  languages: Languages,
  layers: Layers,
  lightbulb: Lightbulb,
  'list-checks': ListChecks,
  lock: Lock,
  'lock-open': LockOpen,
  'log-in': LogIn,
  'log-out': LogOut,
  mail: Mail,
  menu: Menu,
  moon: Moon,
  'more-horizontal': Ellipsis,
  'octagon-alert': OctagonAlert,
  palette: Palette,
  pause: Pause,
  pencil: Pencil,
  play: Play,
  plus: Plus,
  'refresh-cw': RefreshCw,
  'rotate-ccw': RotateCcw,
  'rotate-ccw-clock': RotateCcwClock,
  'rotate-cw': RotateCw,
  save: Save,
  search: Search,
  'search-x': SearchX,
  settings: Settings,
  'share-2': Share2,
  'shield-alert': ShieldAlert,
  'sliders-horizontal': SlidersHorizontal,
  square: Square,
  target: Target,
  timer: Timer,
  hourglass: Hourglass,
  'trash-2': Trash,
  trash: Trash,
  'triangle-alert': TriangleAlert,
  trophy: Trophy,
  unlock: LockOpen,
  upload: Upload,
  user: User,
  'user-check': UserCheck,
  'user-cog': UserCog,
  'user-minus': UserMinus,
  'user-plus': UserPlus,
  users: Users,
  'users-round': UsersRound,
  wifi: Wifi,
  'wifi-off': WifiOff,
  x: X,
  zap: Zap,
  'zap-off': ZapOff
} as const;

export type IconName = keyof typeof ICONS;